import { DateTime } from "luxon";

/**
 * @param weekday 0 = Sunday, 1 = Monday
 * @returns e.g. "Sunday"
 */
export function toLocaleWeekday(weekday: number) {
  return DateTime.utc().set({ weekday }).weekdayLong;
}
